import { EditableExpenditure, Expenditure } from './hooks/useExpenditures';
import { EditableIncome, Income } from './hooks/useIncomes';
import { LifeEvent } from './hooks/useLifeEvents';

export function toEditableIncome(income: Income): EditableIncome {
  return {
    id: income.id,
    clientId: income.clientId,
    description: income.description,
    incomeType: income.incomeType,
    frequency: income.frequency,
    amountPreTax: income.amountPreTax,
    amountPostTax: income.amountPostTax,
  };
}

export function toEditableExpenditure(expenditure: Expenditure): EditableExpenditure {
  return {
    id: expenditure.id,
    clientId: expenditure.clientId,
    description: expenditure.description,
    category: expenditure.category,
    frequency: expenditure.frequency,
    amount: expenditure.amount,
  };
}

export function toEditableLifeEvent(lifeEvent: LifeEvent): LifeEvent {
  return {
    id: lifeEvent.id,
    clientId: lifeEvent.clientId,
    description: lifeEvent.description,
    cost: lifeEvent.cost,
    details: lifeEvent.details,
    eventDate: lifeEvent.eventDate,
  };
}
